export const KEYCODE_RETURN = 3
export const KEYCODE_ENTER = 13
export const KEYCODE_BACKSPACE = 8
export const KEYCODE_DELETE = 46
export const KEYCODE_SHIFT = 16
export const KEYCODE_CONTROL = 17
export const KEYCODE_ESC = 27

export const BLACK_KEYS = [1, 3, 6, 8, 10]
